
























































import { Component, Vue, Prop } from "vue-property-decorator";
import { Plan } from "@foxone/api/src/models/hfox";
import ToushiAction from "./ToushiAction.vue";

@Component({
  components: {
    ToushiAction
  }
})
class PlanAction extends Vue {
  @Prop() plan!: Plan;

  @Prop() id!: string;

  disabled = false;

  loading = false;

  fab = false;

  get isActive() {
    return this.plan.status === "ACTIVE";
  }

  get isStop() {
    return this.plan.status === "STOP";
  }

  handleToEdit() {
    this.$helper.toFusionPath(this, "hfox", { name: "plan-id-edit" });
  }

  async handleStopPlan() {
    this.loading = true;
    await this.requestStopPlan();
    this.$emit("reload");
    this.$common.utils.helper.toast(this, {
      message: this.$t("hfox.plan.stop.success") as string,
      color: "success"
    });
    this.loading = false;
  }

  async handleActivePlan() {
    this.loading = true;
    await this.requestActivePlan();
    this.$emit("reload");
    this.loading = false;
  }

  async handleDeletePlanConfirm() {
    this.$helper.message(
      this,
      {
        title: this.$t("hfox.plan.delete.title") as string,
        description: this.$t("hfox.plan.delete.description") as string,
        ok: this.$t("common.ok") as string,
        okColor: "error"
      },
      {
        onOK: () => this.handleDeletePlan()
      }
    );
  }

  async handleDeletePlan() {
    this.loading = true;
    await this.requestDeletePlan();
    this.$router.back();
    this.$common.utils.helper.toast(this, {
      message: this.$t("hfox.plan.delete.success") as string,
      color: "success"
    });
    this.loading = false;
  }

  async requestStopPlan() {
    try {
      await this.$api.hfox.requestUpdatePlan(this.id, { status: "STOP" });
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  async requestActivePlan() {
    try {
      await this.$api.hfox.requestUpdatePlan(this.id, { status: "ACTIVE" });
      this.$common.utils.helper.toast(this, {
        message: this.$t("hfox.plan.active.success") as string,
        color: "success"
      });
    } catch (error) {
      if ((error as any).code === 10205) {
        this.$common.utils.helper.message(
          this,
          {
            title: this.$t("hfox.plan.deprecated.title") as string,
            description: this.$t("hfox.plan.deprecated.description") as string,
            ok: this.$t("hfox.plan.delete") as string,
            cancel: this.$t("common.got-it") as string,
            okColor: "error"
          },
          {
            onOK: () => {
              this.handleDeletePlan();
            }
          }
        );
        return;
      }
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  async requestDeletePlan() {
    try {
      await this.$api.hfox.requestDeletePlan(this.id);
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }
}
export default PlanAction;
